/**
 * "The session behind this tab is gone" (September audit).
 *
 * The API client sees the 401; the shell owns the identity. Until this
 * existed nothing connected the two: a request answered 401 became a red
 * banner with the server's sentence, and the shell stayed up with the old
 * name in the header over an empty page. The client raises this, once per
 * response, for any household request; the shell subscribes and clears the
 * identity so the sign-in form renders where the person is.
 *
 * A module-level listener set rather than a `window` event so the client
 * stays free of the DOM and the node-lane tests can drive it.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export function subscribeSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifySessionExpired(): void {
  for (const listener of [...listeners]) listener();
}
